export const environment = {
  title: 'Patient Portal Admin Dashboard',
  production: false,
  name: 'PatientPortalAdminDashboard:Dev',
  version: '1.0.0',
  errorMessage: 'Oops something went wrong!',
  loginApiUrl: 'https://medone-patientportal-admin-eastus-dev.azurewebsites.net/api/v1',
  msalConfig: {
    auth: {
      clientId: 'b4ae7689-d5f1-4eb2-908f-76babac969ae',
      authority:
        'https://medonesystemspatportaladmin.ciamlogin.com/1c35176e-8dab-492a-ab55-7d32fb8b8cbf/v2.0',
      redirectUri: 'https://patientportal-admin-ui-eastus-dev.medonesystems.com',
    },
  },
  loginApiConfig: {
    endpoint: 'api://8e2d953c-99f3-407a-989e-71cad2b21c61',
    scopes: ['api://8e2d953c-99f3-407a-989e-71cad2b21c61/user.read', 'profile', 'openid', 'email'],
  },
  domain: 'medonesystems.com',
};
